import useSWR from 'swr';
import { api } from '@utils/api';

/**
 * Hook to fetch active video ads for in-feed display
 * @returns {object} { ads, isLoading, error }
 */
export const useVideoAds = () => {
    const { data, error, isLoading } = useSWR(
        api('/api/video-ads/active'),
        async (url) => {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch video ads');
            }
            const result = await response.json();
            return result.data || result.ads || [];
        },
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            dedupingInterval: 600000, // 10 minutes - ads don't change often
        }
    );

    return {
        ads: data || [],
        isLoading,
        error,
    };
};

export default useVideoAds;

